<h1 mat-dialog-title>Status</h1>
<div class="warining-dialog-container">{{data.message}}</div>
<div mat-dialog-actions class="align-center">
    <button mat-stroked-button color="basic" class="ms-auto" mat-dialog-close>No</button>
    <button class="ms-3" color="primary" mat-raised-button [mat-dialog-close]="true" cdkFocusInitial
        (click)="coonfirm( )">Yes</button>
</div>